import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { PhxSelectModule } from "../select/select.module";
import { PhxIconModule } from "../icon/icon.module";
import { PhxTagModule } from "../tag/phx-tag.module";
import { PhxTagSelectComponent } from "./phx-tag-select.component";

@NgModule({
  declarations: [
    PhxTagSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PhxIconModule,
    PhxSelectModule,
    PhxTagModule,
  ],
  exports: [
    PhxTagSelectComponent,
  ]
})
export class PhxTagSelectModule { }
